const Experience = () => {
    return (
        <div className="experience">
            <h2>Awards/Other Achievements</h2>

            <ul>
                <li>
                    <i>President's Challenge Winner</i>, New York, USA 2016-2018
                    <ul>
                        <li>Top 10 sales in Ambit Energy</li>
                    </ul>
                </li>
                <li>
                    <i>Top sales in Tesla</i>, ShenZhen, China 2019-2020
                    
                </li>
                <li>
                    <i>Music NFT hits 10million views </i>  2021-present
                </li>
            </ul>
        </div>
    );
}

export default Experience;